/* global window */
'use strict';
const App = require('./app.jsx');
const ReactDOM = require('react-dom');

const renderMethod = !!module.hot ? ReactDOM.render : ReactDOM.hydrate;

const Page = {
    blastoff: function () {

        this.mainElement = renderMethod(
            App,
            window.document.getElementById('app-mount')
        );
    }
};


module.exports = Page;


/* $lab:coverage:off$ */
if (!module.parent) {
    window.page = Page;
    Page.blastoff();
}
/* $lab:coverage:on$ */



// WEBPACK FOOTER //
// client/pages/main/index.jsx